import clsx from 'clsx'
import type { InputHTMLAttributes } from 'react'

export function SearchInput({
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div className={clsx('stryzh-search-input', className)}>
      <span className="stryzh-search-input__icon" aria-hidden>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm0-2a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM20 20l-4.2-4.2"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <input type="search" className="stryzh-search-input__field" {...props} />
    </div>
  )
}
